export default __webpack_public_path__ + "static/media/djoef_logo.062cae70.svg";